/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteCostPeriodInput = {
    id: string;
    personId: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteCostPeriodMutationVariables = {
    input: DeleteCostPeriodInput;
};
export type deleteCostPeriodMutationResponse = {
    readonly deleteCostPeriod: {
        readonly deletedCostPeriodId: string | null;
    } | null;
};
export type deleteCostPeriodMutation = {
    readonly response: deleteCostPeriodMutationResponse;
    readonly variables: deleteCostPeriodMutationVariables;
};



/*
mutation deleteCostPeriodMutation(
  $input: DeleteCostPeriodInput!
) {
  deleteCostPeriod(input: $input) {
    deletedCostPeriodId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCostPeriodInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCostPeriodPayload",
    "kind": "LinkedField",
    "name": "deleteCostPeriod",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedCostPeriodId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteCostPeriodMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteCostPeriodMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteCostPeriodMutation",
    "operationKind": "mutation",
    "text": "mutation deleteCostPeriodMutation(\n  $input: DeleteCostPeriodInput!\n) {\n  deleteCostPeriod(input: $input) {\n    deletedCostPeriodId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ea6ae02d2bc5ab33ecb7be5e1024a470';
export default node;
